import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import {
  Home,
  Users,
  Layers,
  Shield,
  MessageSquare,
  Send,
  MessageCircle,
  FileText,
  Image,
  Lock,
  BarChart3,
  Settings,
  Activity,
  HelpCircle,
  User,
  Video,
} from "lucide-react";

import CustomizerContext from "../../_helper/Customizer";

const SidebarMenuItems = ({
  menu,
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
}) => {
  const { layout } = useContext(CustomizerContext);

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  const id = window.location.pathname.split("/").pop();

  const layoutId = id;

  const CurrentPath = window.location.pathname;

  const { t } = useTranslation();

  // =========================
  // ICONS
  // =========================

  const iconMap = {
    home: Home,

    users: Users,
    layers: Layers,
    shield: Shield,

    "message-square": MessageSquare,
    send: Send,
    "message-circle": MessageCircle,

    "file-text": FileText,
    image: Image,
    lock: Lock,

    "bar-chart": BarChart3,

    settings: Settings,
    activity: Activity,
    "help-circle": HelpCircle,

    user: User,
    video: Video,
  };

  // =========================
  // HELPERS
  // =========================

  const stripLayoutId = (path) => {
    if (!path) return "";

    const parts = path.split("/");

    if (parts[parts.length - 1] === layoutId) {
      return parts.slice(0, -1).join("/");
    }

    return path;
  };

  const cleanCurrentPath = stripLayoutId(CurrentPath);

  const isPathActive = (itemPath) => {
    if (!itemPath) return false;

    const cleanItemPath = stripLayoutId(itemPath);

    return (
      cleanCurrentPath === cleanItemPath ||
      cleanCurrentPath.startsWith(cleanItemPath + "/")
    );
  };

  const isSubActive = (item) => {
    if (!item.children) return false;

    return item.children.some(
      (child) => isPathActive(child.path) || isSubActive(child),
    );
  };

  // =========================
  // TOGGLE
  // =========================

  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className =
        "page-header close_icon";

      document.querySelector(".sidebar-wrapper").className =
        "sidebar-wrapper close_icon ";

      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header";

        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper";
      }
    }

    if (!item.active) {
      menu.forEach((a) => {
        a.Items.forEach((menuItem) => {
          if (menuItem !== item) menuItem.active = false;

          if (menuItem.children) {
            menuItem.children.forEach((child) => {
              if (child !== item) child.active = false;

              if (child.children) {
                child.children.forEach((grandchild) => {
                  if (grandchild !== item) grandchild.active = false;
                });
              }
            });
          }
        });
      });
    }

    item.active = !item.active;

    setMainMenu([...menu]);
  };

  // =========================
  // RENDER
  // =========================

  return (
    <>
      {menu.map((Item, i) => (
        <Fragment key={i}>
          <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(Item.menutitle)}</h6>
            </div>
          </li>

          {Item.Items.map((menuItem, i) => {
            const subIsActive = isSubActive(menuItem);

            return (
              <li className="sidebar-list" key={i}>
                {/* =========================
                    SUB MENU
                ========================= */}

                {menuItem.type === "sub" && (
                  <a
                    href="/#"
                    className={`sidebar-link sidebar-title ${
                      menuItem.active || subIsActive ? "active" : ""
                    }`}
                    onClick={(event) => {
                      event.preventDefault();

                      setNavActive(menuItem);

                      activeClass(menuItem.active);
                    }}
                  >
                    {menuItem.icon &&
                      (() => {
                        const IconComponent = iconMap[menuItem.icon];

                        return IconComponent ? (
                          <IconComponent size={18} className="sidebar-icon" />
                        ) : null;
                      })()}

                    <span>{t(menuItem.title)}</span>

                    {menuItem.badge && (
                      <label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </label>
                    )}

                    <div className="according-menu">
                      {menuItem.active || subIsActive ? (
                        <i className="fa fa-angle-down"></i>
                      ) : (
                        <i className="fa fa-angle-right"></i>
                      )}
                    </div>
                  </a>
                )}

                {/* =========================
                    DIRECT LINK
                ========================= */}

                {menuItem.type === "link" && (
                  <Link
                    to={menuItem.path + "/" + layoutId}
                    className={`sidebar-link sidebar-title link-nav ${
                      isPathActive(menuItem.path) ? "active" : ""
                    }`}
                    onClick={() => toggletNavActive(menuItem)}
                  >
                    {menuItem.icon &&
                      (() => {
                        const IconComponent = iconMap[menuItem.icon];

                        return IconComponent ? (
                          <IconComponent size={18} className="sidebar-icon" />
                        ) : null;
                      })()}

                    <span>{t(menuItem.title)}</span>

                    {menuItem.badge && (
                      <label className={menuItem.badge}>
                        {menuItem.badgetxt}
                      </label>
                    )}
                  </Link>
                )}

                {/* =========================
                    SUBMENU CHILDREN
                ========================= */}

                {menuItem.children && (
                  <ul
                    className="sidebar-submenu"
                    style={
                      layout1 !== "compact-sidebar compact-small"
                        ? menuItem.active || subIsActive
                          ? sidebartoogle
                            ? {
                                opacity: 1,
                                transition: "opacity 500ms ease-in",
                              }
                            : {
                                display: "block",
                              }
                          : {
                              display: "none",
                            }
                        : {
                            display: "none",
                          }
                    }
                  >
                    {menuItem.children.map((childrenItem, index) => {
                      const childSubActive = isSubActive(childrenItem);

                      return (
                        <li key={index}>
                          {/* CHILD SUB */}

                          {childrenItem.type === "sub" && (
                            <a
                              href="/#"
                              className={
                                childrenItem.active || childSubActive
                                  ? "active"
                                  : ""
                              }
                              onClick={(event) => {
                                event.preventDefault();

                                toggletNavActive(childrenItem);
                              }}
                            >
                              {t(childrenItem.title)}

                              <span className="sub-arrow">
                                <i className="fa fa-chevron-right"></i>
                              </span>

                              <div className="according-menu">
                                {childrenItem.active || childSubActive ? (
                                  <i className="fa fa-angle-down"></i>
                                ) : (
                                  <i className="fa fa-angle-right"></i>
                                )}
                              </div>
                            </a>
                          )}

                          {/* CHILD LINK */}

                          {childrenItem.type === "link" && (
                            <Link
                              to={childrenItem.path + "/" + layoutId}
                              className={
                                isPathActive(childrenItem.path) ? "active" : ""
                              }
                              onClick={() => toggletNavActive(childrenItem)}
                            >
                              {t(childrenItem.title)}
                            </Link>
                          )}

                          {/* GRAND CHILD */}

                          {childrenItem.children && (
                            <ul
                              className="nav-sub-childmenu submenu-content"
                              style={
                                isPathActive(childrenItem.path) ||
                                childrenItem.active ||
                                childSubActive
                                  ? {
                                      display: "block",
                                    }
                                  : {
                                      display: "none",
                                    }
                              }
                            >
                              {childrenItem.children.map(
                                (childrenSubItem, key) => (
                                  <li key={key}>
                                    {childrenSubItem.type === "link" && (
                                      <Link
                                        to={
                                          childrenSubItem.path + "/" + layoutId
                                        }
                                        className={
                                          isPathActive(childrenSubItem.path)
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() =>
                                          toggletNavActive(childrenSubItem)
                                        }
                                      >
                                        {t(childrenSubItem.title)}
                                      </Link>
                                    )}
                                  </li>
                                ),
                              )}
                            </ul>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
